
import { formatPrice } from './Formatter';

export default class CostItem {
  constructor (name, detail, unitPrice = 0, amount, unit) {
    this.name = name;
    this.detail = detail;
    this.unitPrice = unitPrice;
    this.amount = amount;
    this.unit = unit;
    this.price = (typeof unitPrice == 'number') ? unitPrice * amount : unitPrice;
  }

  row () {
    return [
      `${this.name} (${this.detail})`,
      formatPrice(this.unitPrice),
      this.amount,
      this.unit,
      formatPrice(this.price)
    ];
  }

  get formattedPrice () {
    if(typeof this.price == 'number'){
      return formatPrice(this.price);
    } else{
      return this.price;
    }
  }
}

const calculateCostTotal = function (items) {
  return items.reduce((pre, cur) => {
    return pre + cur.price;
  }, 0);
};

export {
  calculateCostTotal
};



// WEBPACK FOOTER //
// ./src/assets/javascripts/CostItem.js